import { createAppSlice } from 'app/createAppSlice'
import moment from 'moment-timezone'

const initialState = {
  filterPeriod: {
    month: moment().month() + 1,
    year: moment().format('YYYY'),
    selectedMonthYear: new Date(),
  },
  tag: {
    page: 0,
    size: 9999,
    sortby: 'name',
    sortdir: 'asc',
    search: '',
  },
  historyTag: {
    page: 0,
    size: 10,
    sortby: 'createdAt',
    sortdir: 'DESC',
    search: '',
  },
  loading: false,
  activeTab: 'disbursement',
  disbursementData: {
    batchName: '',
    disburses: [],
  },
  employeeEdit: null,
  isOpenModalManual: false,
  isOpenModalAuto: false,
}

export const employeePaymentsListSlice = createAppSlice({
  name: 'employeePaymentsList',
  initialState,
  reducers: (create) => ({
    setFilterPeriod: create.reducer((state, { payload }) => {
      state.filterPeriod = { ...state.filterPeriod, ...payload }
    }),
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setHistoryFetchOption: create.reducer((state, { payload }) => {
      state.historyTag = { ...state.historyTag, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
    setActiveTab: create.reducer((state, { payload }) => {
      state.activeTab = payload
    }),
    setIsOpenModalManual: create.reducer((state, { payload }) => {
      state.isOpenModalManual = payload
    }),
    setIsOpenModalAuto: create.reducer((state, { payload }) => {
      state.isOpenModalAuto = payload
    }),
    setEmployeeEdit: create.reducer((state, { payload }) => {
      state.employeeEdit = payload
    }),
    setBatchName: create.reducer((state, { payload }) => {
      state.disbursementData.batchName = payload
    }),
    // THIS IS FOR DEFAULT DISBURSES
    setDisbursementDataDisburses: create.reducer((state, { payload }) => {
      state.disbursementData.disburses = payload
    }),
    // SET ALL AUTO CALCULATE
    setAutoCalculateDisbursements: create.reducer((state, { payload }) => {
      state.disbursementData.batchName = payload.batchName
      state.disbursementData.disburses = payload.disburses.map((item) => ({
        ...item,
        source: 'auto',
      }))
    }),
    // UPDATE MANUAL DISBURSES
    setManualDisbursement: create.reducer((state, { payload }) => {
      const {
        employeeUserId,
        employeeName,
        amount,
        notes,
        disburseMethod,
        rolesName,
        createdAt,
      } = payload

      if (!state.disbursementData) {
        state.disbursementData = { batchName: '', disburses: [] }
      }
      if (!state.disbursementData.disburses) {
        state.disbursementData.disburses = []
      }

      // CHECK EXISTING
      const existingIndex = state.disbursementData.disburses.findIndex(
        (d) => d.employeeUserId === employeeUserId,
      )

      if (existingIndex !== -1) {
        state.disbursementData.disburses[existingIndex] = {
          ...state.disbursementData.disburses[existingIndex],
          amount: amount || 0,
          disburseMethod: disburseMethod || 'CASH',
          notes: notes || '',
          source: 'manual',
          createdAt: createdAt || new Date().toISOString(),
        }
      } else {
        // ADD NEW
        state.disbursementData.disburses.push({
          unit: 0,
          employeeUserId,
          employeeName,
          nameItem: '',
          prIds: '',
          itemId: null,
          amount: amount || 0,
          disburseMethod: disburseMethod || 'CASH',
          notes: notes || '',
          proofImgs: '',
          processreportIds: [],
          rolesName: rolesName || '',
          source: 'manual',
          createdAt: createdAt || new Date().toISOString(),
        })
      }
    }),
    // UPDATE DISBURSEMENT YANG SUDAH ADA
    updateDisbursement: create.reducer((state, { payload }) => {
      const { employeeUserId, data } = payload

      const index = state.disbursementData.disburses.findIndex(
        (d) => d.employeeUserId === employeeUserId,
      )

      if (index !== -1) {
        state.disbursementData.disburses[index] = {
          ...state.disbursementData.disburses[index],
          ...data,
        }
      }
    }),
    // RESET AMOUNT, NOTES, AND PAYMENT METHOD
    resetDisbursementByEmployeeId: create.reducer((state, { payload }) => {
      const employeeUserId = payload

      if (!state.disbursementData?.disburses) {
        return
      }

      const index = state.disbursementData.disburses.findIndex(
        (d) => d.employeeUserId === employeeUserId,
      )

      if (index !== -1) {
        state.disbursementData.disburses[index] = {
          ...state.disbursementData.disburses[index],
          amount: 0,
          notes: '',
          disburseMethod: '',
          source: undefined,
        }
      }
    }),
    // CLEAR TO DEFAULT VALUE
    clearDisbursements: create.reducer((state) => {
      state.disbursementData = {
        batchName: '',
        disburses: [],
      }
    }),
    // UPDATE PROOF IMAGE BY INDEX
    updateDisbursementProofImg: create.reducer((state, { payload }) => {
      const { index, proofImgs } = payload

      if (state.disbursementData?.disburses?.[index]) {
        state.disbursementData.disburses[index].proofImgs = proofImgs
      }
    }),
    // AUTOCALCULATE
    setDisbursementData: create.reducer((state, { payload }) => {
      state.disbursementData = payload
    }),
    // UPDATE SPECIFIC FIELD IN DISBURSE ITEM (FOR AUTO CALCULATION)
    updateDisbursementField: create.reducer((state, { payload }) => {
      const { employeeUserId, itemId, field, value } = payload

      if (!state.disbursementData?.disburses) {
        return
      }

      const index = state.disbursementData.disburses.findIndex(
        (d) => d.employeeUserId === employeeUserId && d.itemId === itemId,
      )

      if (index !== -1) {
        state.disbursementData.disburses[index][field] = value
      }
    }),
  }),
})

export const {
  setFilterPeriod,
  setFetchOption,
  setHistoryFetchOption,
  setLoading,
  setActiveTab,
  setIsOpenModalManual,
  setIsOpenModalAuto,
  setBatchName,
  setAutoCalculateDisbursements,
  setManualDisbursement,
  updateDisbursement,
  removeDisbursement,
  clearDisbursements,
  setDisbursementDataDisburses,
  setEmployeeEdit,
  resetDisbursementByEmployeeId,
  updateDisbursementProofImg,
  setDisbursementData,
  updateDisbursementField,
} = employeePaymentsListSlice.actions

export default employeePaymentsListSlice.reducer
